// extracted by mini-css-extract-plugin
module.exports = {"artifact-link":"spec-artifacts-page-content_artifact-link__ChHpl"};